import { render } from "./KioskSpotRegistrationView.vue?vue&type=template&id=d8c1520e"
import script from "./KioskSpotRegistrationView.vue?vue&type=script&lang=js"
export * from "./KioskSpotRegistrationView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__